import { ReactElement } from 'react';

import { DashboardVariantV2GiverContentContainer } from './styles';
import DashboardVariantV2GiverContentTabs from './Tabs';

const DashboardVariantV2GiverContent = (): ReactElement => (
  <DashboardVariantV2GiverContentContainer>
    <DashboardVariantV2GiverContentTabs />
  </DashboardVariantV2GiverContentContainer>
);

export default DashboardVariantV2GiverContent;
